import { Card, Chip, DateColumn, Typography } from '@otp/ui';
import {
  IssueTicket,
  IssueTicketsDocument,
  StoreModel,
} from 'src/graphql/generated/graphql';
import { getFullName } from 'src/utils/user-data';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useState } from 'react';
import { formatIssueTicketId } from '../utils/utils';
import { IssueTicketDetails } from '../details/details';
import { ImportanceField } from '../list/table/columns/importance';
import styles from './item.module.css';
import { StatusField } from '../list/table/columns/status';
import { ActionsColumn } from '../list/table/columns/actions';

export type IssueTicketPreview = Pick<
  IssueTicket,
  | 'id'
  | 'idNumber'
  | 'name'
  | 'description'
  | 'status'
  | 'importance'
  | 'createdAt'
> & {
  createdBy: {
    firstName: string;
    lastName: string;
  };
  stores: Partial<StoreModel>[];
};

type IssueTicketPreviewItemProps = {
  ticket: IssueTicketPreview;
};
export const IssueTicketsPreviewItem = ({
  ticket,
}: IssueTicketPreviewItemProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.list',
  });

  const [displayDetails, setDisplayDetails] = useState(false);

  return (
    <>
      <Card
        className={clsx(styles.wrapper, 'flex flex-col w-full gap-1 mb-2')}
        isLink={true}
        onClick={() => {
          setDisplayDetails(true);
        }}
      >
        <div className="flex justify-between  gap-2">
          <Typography variant="body2" fontWeight="bold" className={styles.name}>
            {ticket.name}
          </Typography>
          <div className="flex gap-2">
            <Chip label={formatIssueTicketId(ticket)} />
            <ActionsColumn issueTicket={ticket} />
          </div>
        </div>
        <div className="flex justify-between  gap-2">
          <Typography variant="subtitle1" fontWeight="bold">
            {t('preview.by')} {getFullName(ticket.createdBy, ' ')}
          </Typography>
          <Typography variant="subtitle1" fontWeight="bold">
            <DateColumn date={ticket.createdAt} withTime />
          </Typography>
        </div>

        <div className="flex mt-2">
          <StatusField status={ticket.status} />
          <ImportanceField importance={ticket.importance} />
        </div>
      </Card>
      {displayDetails && (
        <IssueTicketDetails
          issueTicketId={ticket.id}
          disabledFields={{ storeIds: true }}
          refetchQueries={[IssueTicketsDocument]}
          onClose={() => setDisplayDetails(false)}
        />
      )}
    </>
  );
};
